import {
	Button, Flex, For, HStack,
} from '@chakra-ui/react';
import { Fragment } from 'react';

import { AppRoutes, getRoute } from '@/constants/route';
import { LocaleMenu, NextLinkWrapper } from '@/modules/navigation/presentation/components';
import { PlusUpLogo } from '@/modules/shared/presentation';
import { setUserLocale } from '@/utils';

type NavItem = {
	href:        string
	isExternal?: boolean
	label:       string
};

const leftItems: NavItem[] = [
	{ href: AppRoutes.jobs.search, label: 'Search Job' },
	{ href: AppRoutes.jobs.new, label: 'New Job' },
	{ href: AppRoutes.jobs.popular, label: 'Popular Job' },
	{ href: AppRoutes.jobs.featured, label: 'Special Feature' },
] as const;

const leftItemsAuth: NavItem[] = [
	{ href: AppRoutes.jobs.search, label: 'Search Job' },
	{ href: AppRoutes.jobs.saved, label: 'Interested' },
	{ href: AppRoutes.offers.list, label: 'Offer' },
	{ href: AppRoutes.messages.list, label: 'Entry • Message' },
] as const;

type NavbarProps = {
	isAuthenticated: boolean

	onClickLogout?: () => void
};

export const Navbar = ({ isAuthenticated, onClickLogout }: NavbarProps) => {
	const leftNavItems = isAuthenticated ? leftItemsAuth : leftItems;

	return (
		<Flex as="nav" justifyContent="space-between">
			<NextLinkWrapper aria-label="Home" href="/">
				<PlusUpLogo />
			</NextLinkWrapper>
			<HStack gap={6}>
				<For each={leftNavItems}>
					{(item, index) => (
						<NextLinkWrapper href={item.href as never} key={`${item.href}-${index}`}>
							{item.label}
						</NextLinkWrapper>
					)}
				</For>
				<LocaleMenu onSelect={setUserLocale} />
				{isAuthenticated
					? (
							<Fragment>
								<NextLinkWrapper href={AppRoutes.account.settings.index}>Settings</NextLinkWrapper>
								<NextLinkWrapper href={AppRoutes.account.settings.index}>Help</NextLinkWrapper>
								<Button onClick={onClickLogout}>Logout</Button>
								<NextLinkWrapper href={getRoute.profile.index()}>Profile</NextLinkWrapper>
							</Fragment>
						)
					: (
							<Fragment>
								<NextLinkWrapper href={AppRoutes.auth.login}>Login</NextLinkWrapper>
								<NextLinkWrapper href={AppRoutes.auth.register}>Register</NextLinkWrapper>
							</Fragment>
						)}
			</HStack>
		</Flex>
	);
};
